import React, { useEffect, useState } from "react";
import AutoComplete from 'material-ui/AutoComplete';
import useDebounce from "helpers/useDebounce";
import api from "services";

/**
 * 
 * @param {{
 *  customValue?: string,
 *  style?: React.CSSProperties,
 *  popoverProps?: React.CSSProperties,
 *  textFieldStyle?: React.CSSProperties,
 *  underlineStyle?: React.CSSProperties,
 *  floatingLabelStyle?: React.CSSProperties,
 *  inputStyle?: React.CSSProperties,
 *  menuStyle?: React.CSSProperties,
 *  disabled?: boolean,
 *  hintText?: string,
 *  hintStyle?: React.CSSProperties,
 *  onCompanySelected: Function,
 *  resetInput?: boolean,
 *  withRealCompanies?: boolean,
 *  onlyWithOwner?: boolean,
 * }} param0 
 * @returns 
 */
export default function CompaniesAutoComplete({
    customValue = '',
    style = {},
    popoverProps = {},
    textFieldStyle = {},
    underlineStyle = {},
    floatingLabelStyle = {},
    inputStyle = {},
    menuStyle = {},
    hintStyle = {},
    disabled = false,
    hintText = '',
    onCompanySelected = (val) => {},
    resetInput = false,
    withRealCompanies = false,
    onlyWithOwner = false,
}) {
    const [companyValue, setCompanyValue] = useState(customValue);
    const [companies, setCompanies] = useState([]);
    const [preventFirstSearch, setPreventFirstSearch] = useState(true);
    const [company, setCompany] = useState(null);

    const debouncedSearchValue = useDebounce(companyValue, 500);

    useEffect(() => {
        setPreventFirstSearch(false);
    }, []);

    useEffect(() => {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        api.findCompany(debouncedSearchValue, withRealCompanies, onlyWithOwner)
            .then((response) => {
                const _companies = response.data.data.map(_company => ({
                    name: _company.name,
                    item: _company,
                }));

                setCompanies(_companies);
            })
            .catch(() => null);
    }, [debouncedSearchValue]);

    useEffect(() => {
        setCompanyValueFromOutside()
    }, [resetInput]);

    const changeCompanyValue = (val) => {
        setCompanyValue(val);
    };

    const chooseCompany = (val) => {
        setCompany(val);
        onCompanySelected(val);
    };

    const setCompanyValueFromOutside = () => {
        setCompanyValue('');
    }

    return (
        <AutoComplete
            name='company'
            value={companyValue}
            searchText={companyValue}
            dataSource={companies}
            dataSourceConfig={{ text: 'name', value: 'item' }}
            hintText={hintText || 'Company filter'}
            onUpdateInput={val => changeCompanyValue(val)}
            onNewRequest={val => chooseCompany(val)}
            filter={AutoComplete.noFilter}
            textFieldStyle={{ fontSize: '13px', ...textFieldStyle }}
            style={style}
            underlineStyle={{ ...underlineStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            fullWidth={!style.width}
            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
            inputStyle={{ ...inputStyle }}
            popoverProps={{
                canAutoPosition: true,
                ...popoverProps,
            }}
            menuStyle={{ ...menuStyle }}
            disabled={disabled}
            hintStyle={{ ...hintStyle }}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/common/CompaniesAutoComplete.jsx